import { SectionCard } from "@/components/shared/PageChrome";

// Access guidance reflecting the permissions as implemented today (backend: require_workspace(org_type) only; user and role
// management under /admin for JIGSAW_ADMIN). Wording must change when the permission model changes — nothing here is aspirational.
const GUIDES = {
  CLIENT: {
    title: "Access in the client workspace",
    rows: [
      ["Client Admin and Client User", "Currently hold the same permissions: view your organisation's requests, offers, bookings and documents; accept or decline presented offers; message Jigsaw support."],
      ["Adding or removing people", "Managed by Jigsaw Admin. Ask via Support — there is no self-service user or role management in this workspace."],
      ["What you cannot see", "Other organisations' data, supplier pricing internals and Jigsaw internal notes."],
    ],
  },
  SUPPLIER: {
    title: "Access in the supplier workspace",
    rows: [
      ["Supplier Admin and Supplier User", "Currently hold the same permissions: view open sourcing requests, submit one offer per request, maintain properties and compliance documents, complete onboarding submissions."],
      ["Adding or removing people", "Managed by Jigsaw Admin. Ask Jigsaw — there is no self-service user or role management in this workspace."],
      ["What you cannot see", "Client identities and contact details on requests, other suppliers' offers and Jigsaw internal notes."],
    ],
  },
};

export const AccessGuide = ({ workspace }) => {
  const g = GUIDES[workspace];
  if (!g) return null;
  return (
    <SectionCard testId={`access-guide-${workspace.toLowerCase()}`} title={g.title} subtitle="How roles and access work today">
      <dl className="grid gap-3 text-sm">
        {g.rows.map(([k, v]) => (
          <div key={k} className="grid gap-1 sm:grid-cols-[220px_1fr] sm:gap-4">
            <dt className="font-medium text-jigsaw-navy">{k}</dt>
            <dd className="text-jigsaw-muted">{v}</dd>
          </div>
        ))}
      </dl>
    </SectionCard>
  );
};
